// @flow

import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { history } from "./router/index";

import appReducer from "./store/app/appReducer";

export type RoutingReducerType = {|
  location: {|
    pathname: string,
    search: string,
    hash: string,
  |},
|};

export type AppStateType = {|
  router: RoutingReducerType,
|};

const appState: AppStateType = {
  router: connectRouter(history),
  app: appReducer,
};

export default combineReducers(appState);
